var _g, _line, _line2, _line3, _line4, _polyline, _line5, _line6, _g2, _line7, _line8, _line9, _g3, _polyline2, _line10, _line11, _g4, _line12, _line13, _line14, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDatenuebersicht(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "20px",
    viewBox: "0 0 40 20",
    enableBackground: "new 0 0 40 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    d: "M14.746,1.66c0,0-0.33,0-0.33,0.33v16.02 c0,0,0,0.33,0.33,0.33h10.508c0,0,0.33,0,0.33-0.33V6.572c0,0,0-0.33-0.33-0.33h-4.016c0,0-0.33,0-0.33-0.33V1.99 c0,0,0-0.33-0.33-0.33H14.746z"
  }), /*#__PURE__*/React.createElement("line", {
    clipPath: "url(#SVGID_2_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    x1: 20.848,
    y1: 1.66,
    x2: 25.5,
    y2: 6.312
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 16.875,
    y1: 6.347,
    x2: 18.375,
    y2: 6.347
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 16.875,
    y1: 9.347,
    x2: 22.975,
    y2: 9.347
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 16.875,
    y1: 12.347,
    x2: 22.975,
    y2: 12.347
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    x1: 16.875,
    y1: 15.347,
    x2: 22.975,
    y2: 15.347
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    points: "3.5,5.722 3.5,9 11.367,9 "
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 9.562,
    y1: 7.062,
    x2: 11.438,
    y2: 9
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 9.562,
    y1: 10.938,
    x2: 11.438,
    y2: 9
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_4_)",
    fill: "#FFFFFF",
    d: "M3.5,5.625c1.174,0,2.125-0.951,2.125-2.125S4.674,1.375,3.5,1.375 S1.375,2.326,1.375,3.5S2.326,5.625,3.5,5.625"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_4_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    cx: 3.5,
    cy: 3.5,
    r: 2.125
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 4,
    y1: 15.5,
    x2: 11.367,
    y2: 15.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 9.562,
    y1: 13.562,
    x2: 11.438,
    y2: 15.499
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 9.562,
    y1: 17.438,
    x2: 11.438,
    y2: 15.501
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_6_)",
    fill: "#FFFFFF",
    d: "M4.5,17.625c1.174,0,2.125-0.951,2.125-2.125S5.674,13.375,4.5,13.375 S2.375,14.326,2.375,15.5S3.326,17.625,4.5,17.625"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_6_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    cx: 4.5,
    cy: 15.5,
    r: 2.125
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    points: "36.5,14.278 36.5,11 28.633,11 "
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 30.438,
    y1: 12.938,
    x2: 28.562,
    y2: 11.001
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 30.438,
    y1: 9.062,
    x2: 28.562,
    y2: 11
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_8_)",
    fill: "#FFFFFF",
    d: "M36.5,14.375c-1.174,0-2.125,0.951-2.125,2.125s0.951,2.125,2.125,2.125 s2.125-0.951,2.125-2.125S37.674,14.375,36.5,14.375"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_8_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    cx: 36.5,
    cy: 16.5,
    r: 2.125
  }))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 36,
    y1: 4.5,
    x2: 28.633,
    y2: 4.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 30.438,
    y1: 6.438,
    x2: 28.562,
    y2: 4.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    x1: 30.438,
    y1: 2.562,
    x2: 28.562,
    y2: 4.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    width: 40,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("path", {
    clipPath: "url(#SVGID_10_)",
    fill: "#FFFFFF",
    d: "M35.5,2.375c-1.174,0-2.125,0.951-2.125,2.125s0.951,2.125,2.125,2.125 s2.125-0.951,2.125-2.125S36.674,2.375,35.5,2.375"
  }), /*#__PURE__*/React.createElement("circle", {
    clipPath: "url(#SVGID_10_)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    cx: 35.5,
    cy: 4.5,
    r: 2.125
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatenuebersicht);
export default __webpack_public_path__ + "static/media/datenuebersicht.7a141f407825cb579438c6e24c7cad16.svg";
export { ForwardRef as ReactComponent };